/**
 * @generated by Icons/generate-icons.ts — do not edit by hand.
 * Source: svg/W2.svg. Edit that .svg (or svg/icons.config.json) and run
 * `pnpm --filter @gigpro/ui generate:icons`.
 */
import type { IconComponent } from "./types";

export const W2: IconComponent = ({ ref, color = "currentColor", ...props }) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20" ref={ref} {...props}>
    <title>W2</title>
    <path
      fill={color}
      d="M11.4 18.98q.42.18.87.18c.76 0 1.5-.38 1.91-1.07l.66-1.1q.13-.2.35-.26l1.26-.28a2.2 2.2 0 0 0 1.72-2.35l-.12-1.27a.5.5 0 0 1 .13-.42l.85-.96a2.2 2.2 0 0 0 0-2.9l-.85-.96a.5.5 0 0 1-.13-.42l.12-1.27a2.2 2.2 0 0 0-1.72-2.35l-1.26-.29a.6.6 0 0 1-.35-.25l-.66-1.1A2.2 2.2 0 0 0 11.4 1l-1.18.5a.6.6 0 0 1-.44 0L8.6 1a2.2 2.2 0 0 0-2.78.89L5.16 3a.5.5 0 0 1-.35.26l-1.26.28a2.2 2.2 0 0 0-1.72 2.35l.12 1.27q.02.23-.13.42l-.85.96a2.2 2.2 0 0 0 0 2.9l.85.96q.16.19.13.42l-.12 1.27a2.2 2.2 0 0 0 1.72 2.35l1.26.28q.22.06.35.26l.66 1.1a2.2 2.2 0 0 0 2.78.9l1.18-.5q.22-.09.44 0z"
    />
    <path
      fill="#fff"
      d="m12.33 11.85-.23.18v.95h3.73v-1.04h-2a8 8 0 0 0 1.38-1.32q.54-.69.54-1.48 0-.73-.45-1.19t-1.33-.45q-.52 0-.94.2t-.68.63-.27 1.05h1.23q0-.38.16-.6.15-.2.44-.2t.43.16q.14.18.14.48 0 .4-.3.82-.27.43-.7.82zm-2.06 1.2 1.36-5.22h-1.37l-.76 3.8-.9-3.8H7.22l-.93 3.8-.75-3.8H4.17l1.32 5.22h1.54l.86-3.44.84 3.44z"
    />
  </svg>
);
W2.displayName = "W2";
